export const environment = {
  production: true,
  envName: 'staging',
  apiUrl: 'https://api.dorado.dev.perare.io',
  mapUrl: 'https://map.sirius.dev.perare.io',
  wsUrl: 'wss://dorado.dev.perare.io/ws/',

  mapboxToken:
    'pk.eyJ1IjoiZnVzY2FyIiwiYSI6ImNseHJ6ZzBpeDAya24yanEweWptcThoM2UifQ.IYSclyar7C4J5CymBw06Rg',
  
  // Sentry DSN for perare-dev project (staging also uses dev)
  sentryDsn: 'https://73b048d01ea8436247111708eac94158@o4507607579426816.ingest.us.sentry.io/4509762309849088',
};
